import type { TranslationKeys } from '@vocab/core';
import { useTranslations } from '@vocab/react';
import { Box, Tabs, Tab, Badge } from 'braid-design-system';

import translations from './.vocab';

export type DetailsTabSelectorTranslationKeys = TranslationKeys<
  typeof translations
>;

export interface TabSelectOption {
  name: DetailsTabSelectorTranslationKeys;
  counts?: number;
  value: string;
  isNew: boolean;
}

interface TabSelect {
  testId: string;
  options: TabSelectOption[];
}

// FIXME: count need to be part of the translation string based on our Vocab guide
const labelWithCount = (label: string, count: number) => {
  const countLabel = count === 0 ? '' : ` (${count})`;
  return `${label}${countLabel}`;
};

const TabSelect = ({ options, testId }: TabSelect) => {
  const { t } = useTranslations(translations);
  const key = options.reduce(
    (acc, option) => `${acc}-${option.counts}-${option.isNew}`,
    '',
  );
  return (
    <Tabs
      key={key}
      reserveHitArea
      label={t('Tab Select')}
      size="small"
      data={{
        testid: testId,
      }}
      divider="full"
    >
      {options.map((tab) => (
        <Tab
          key={tab.value}
          item={tab.value}
          badge={
            tab.isNew ? <Badge tone="positive">{t('New')}</Badge> : undefined
          }
        >
          <Box
            marginY="xsmall"
            display="flex"
            flexDirection="row"
            flexWrap="nowrap"
            alignItems="center"
          >
            <Box>
              {tab.counts
                ? labelWithCount(t(tab.name), tab.counts)
                : t(tab.name)}
            </Box>
          </Box>
        </Tab>
      ))}
    </Tabs>
  );
};

export default TabSelect;
